module.exports = __webpack_public_path__ + "img/image-schedule.9e97cc02.jpg";